import { createSlice } from "@reduxjs/toolkit";
import * as filterActions from "./filterActions";

const InitialState = {
    isLoading: false,
    salesFilter: [],
    servicesFilter: [],
    salesShareFilter: [],
    servicesShareFilter: [],
    escalationsFilter: [],
    escalationsShareFilter: [],
    hasError: false,
};

const filterReducer = createSlice({
    name: "filter",
    initialState: InitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(filterActions.createSalesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createSalesSaveFilter.fulfilled, (state, action) => {
                state.salesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createSalesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getSalesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getSalesSaveFilter.fulfilled, (state, action) => {
                state.salesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getSalesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.deleteSalesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.deleteSalesSaveFilter.fulfilled, (state, action) => {
                state.salesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.deleteSalesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.updateSalesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.updateSalesSaveFilter.fulfilled, (state, action) => {
                state.salesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.updateSalesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getSalesShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getSalesShareFilter.fulfilled, (state, action) => {
                state.salesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getSalesShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.createSalesShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createSalesShareFilter.fulfilled, (state, action) => {
                state.salesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createSalesShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.removeSalesShareFilterUser.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.removeSalesShareFilterUser.fulfilled, (state, action) => {
                state.salesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.removeSalesShareFilterUser.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.createServicesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createServicesSaveFilter.fulfilled, (state, action) => {
                state.servicesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createServicesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getServicesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getServicesSaveFilter.fulfilled, (state, action) => {
                state.servicesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getServicesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.deleteServicesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.deleteServicesSaveFilter.fulfilled, (state, action) => {
                state.servicesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.deleteServicesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.updateServicesSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.updateServicesSaveFilter.fulfilled, (state, action) => {
                state.servicesFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.updateServicesSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getServicesShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getServicesShareFilter.fulfilled, (state, action) => {
                state.servicesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getServicesShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.createServicesShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createServicesShareFilter.fulfilled, (state, action) => {
                state.servicesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createServicesShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.removeServicesShareFilterUser.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.removeServicesShareFilterUser.fulfilled, (state, action) => {
                state.servicesShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.removeServicesShareFilterUser.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
               .addCase(filterActions.createEscalationsSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createEscalationsSaveFilter.fulfilled, (state, action) => {
                state.escalationsFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createEscalationsSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getEscalationsSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getEscalationsSaveFilter.fulfilled, (state, action) => {
                state.escalationsFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getEscalationsSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.deleteEscalationsSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.deleteEscalationsSaveFilter.fulfilled, (state, action) => {
                state.escalationsFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.deleteEscalationsSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.updateEscalationsSaveFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.updateEscalationsSaveFilter.fulfilled, (state, action) => {
                state.escalationsFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.updateEscalationsSaveFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.getEscalationsShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.getEscalationsShareFilter.fulfilled, (state, action) => {
                state.escalationsShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.getEscalationsShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.createEscalationsShareFilter.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.createEscalationsShareFilter.fulfilled, (state, action) => {
                state.escalationsShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.createEscalationsShareFilter.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(filterActions.removeEscalationsShareFilterUser.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(filterActions.removeEscalationsShareFilterUser.fulfilled, (state, action) => {
                state.escalationsShareFilter = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(filterActions.removeEscalationsShareFilterUser.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
    },
});

export default filterReducer.reducer;